import React from 'react'
import './menumiddle.css'
export default function Menumiddle() {
  return (
    <>
    <div className='menuMiddle'>
      <div className='centerMenu'>
        <p>CHOOSE YOUR FAVORITE</p>
        <h2>MENU LIGHT</h2>

      </div>


    </div>
    
    </>
  )
}
